import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  position: absolute;
  top: -10px;
  left: -10px;
  z-index: 1000;
  width: 600px;
  max-width: 90vw;
  margin-top: 0px;

  @media (max-width: 767px) {
    width: 350px;
    left: 50%;
    transform: translateX(-50%);
  }
`;


const TableContainer = styled.div`
  background: rgba(0, 0, 0, 0.95);
  border-radius: 15px;
  padding: 1.5rem;
  border: 2px solid #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  width: 100%;
  min-height: 200px;
  max-height: 300px;
  overflow-y: auto;

  @media (max-width: 767px) {
    max-height: 290px;
  }
`;

const TableTitle = styled.h4`
  color: #fff;
  text-align: center;
  margin-bottom: 1.5rem;
  font-weight: 600;
  font-size: 18px;

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;


const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: #fff;
  font-size: 14px;

  @media (max-width: 767px) {
    font-size: 12px;
  }
`;


const Th = styled.th`
  padding: 0.75rem 0.5rem;
  text-align: left;
  border-bottom: 2px solid #fff;
  border-top: 2px solid #fff;
  color: #fff;
  font-weight: 600;
  font-size: ${window.screen.width > 767 ? "14px" : "12px"};
  
  @media (max-width: 767px) {
    padding: 0.5rem 0.25rem;
    font-size: 11px;
  }
`;

const Td = styled.td`
  padding: 0.75rem 0.5rem;
  border-bottom: 1px solid #333;
  font-size: ${window.screen.width > 767 ? "13px" : "11px"};
  
  @media (max-width: 767px) {
    padding: 0.5rem 0.25rem;
  }
`;

const RarityBadge = styled.span<{ rarity: string }>`
  padding: 0.2rem 0.4rem;
  border-radius: 15px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  
  
`;

const OddsCell = styled(Td)`
  color: white;
  font-weight: 600;
`;

const PriceCell = styled(Td)`
  color: white;
  font-weight: 600;
`;

const VCoinsCell = styled(Td)`
  color: white;
  font-weight: 600;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: rgba(255, 215, 0, 0.1);
  }
`;

interface MysteryBoxInfoProps {
  onClose?: () => void;
}

const MysteryBoxInfo: React.FC<MysteryBoxInfoProps> = ({ onClose }) => {
  const mysteryBoxData = [
    {
      name: "Vote Squad",
      rarity: "Core",
      odds: "30.00%",
      price: "$100",
      vCoins: "$20,000"
    },
    {
      name: "One Key Crew",
      rarity: "Limited",
      odds: "25.00%",
      price: "$250",
      vCoins: "$50,000"
    },
    {
      name: "The Originals",
      rarity: "Iconic",
      odds: "23.00%",
      price: "$1,000",
      vCoins: "$200,000"
    },
    {
      name: "Signal Boosters",
      rarity: "Premium",
      odds: "14.00%",
      price: "$2,000",
      vCoins: "$400,000"
    },
    {
      name: "Vote Icons",
      rarity: "Collector's Choice",
      odds: "5.40%",
      price: "$5,000",
      vCoins: "$1,000,000"
    },
    {
      name: "Loyal Legends",
      rarity: "Special Edition",
      odds: "2.10%",
      price: "$10,000",
      vCoins: "$2,000,000"
    },
    {
      name: "The Equation",
      rarity: "Elite",
      odds: "0.40%",
      price: "$25,000",
      vCoins: "$5,000,000"
    },
    {
      name: "Air Vote",
      rarity: "Ultra",
      odds: "0.10%",
      price: "$50,000",
      vCoins: "$10,000,000"
    }
  ];

  return (
    <Wrapper>
      <TableContainer>
        {onClose && (
          <CloseButton onClick={onClose}>
            ×
          </CloseButton>
        )}
        <TableTitle>Mystery Box</TableTitle>
        <Table >
          <thead>
            <tr>
              <Th>Name</Th>
              <Th>Rarity</Th>
              <Th>Odds</Th>
              <Th>Price</Th>
              <Th>Vcoins</Th>
            </tr>
          </thead>
          <tbody>
            {mysteryBoxData.map((item, index) => (
              <tr key={index}>
                <Td>{item.name}</Td>
                <Td>
                  <RarityBadge rarity={item.rarity}>
                    {item.rarity}
                  </RarityBadge>
                </Td>
                <OddsCell>{item.odds}</OddsCell>
                <PriceCell>{item.price}</PriceCell>
                <VCoinsCell>{item.vCoins}</VCoinsCell>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
    </Wrapper>
  );
};

export default MysteryBoxInfo; 